const toggleSubMenu = (event) => {
  const liEL = event.target.closest("li");
  liEL.classList.toggle("open-sub-menu");
};

function addHeaderSubMenuElements(subMenuElms, spanElm) {
  subMenuElms.forEach((submenu) => {
    const spanClone = spanElm.cloneNode([true]);
    spanClone.addEventListener("click", toggleSubMenu.bind(this));
    const parentEl = submenu.parentElement;
    parentEl.insertBefore(spanClone, submenu);
  });
}

function initOnScrollHeaderEvent(headerEl) {
  window.addEventListener("scroll", () => {
    const scrollPos = window.scrollY;
    if (scrollPos) {
      headerEl.classList.add("scroll");
    } else {
      headerEl.classList.remove("scroll");
    }
  });
}

function toggleMobileMenuHandler(headerEl) {
  headerEl.classList.toggle("show-menu");
}

export function headerInit() {
  const headerEl = document.getElementById("header");
  const mobileToggleEl = document.getElementById("mobile-menu-toggle");
  const mainNavEl = document.getElementById("menu-top-nav");
  const mainNavLinks = mainNavEl.querySelectorAll(".sub-menu");
  const spanEl = document.createElement("span");

  spanEl.className = "sub-link";
  spanEl.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
</svg>`;
  addHeaderSubMenuElements(mainNavLinks, spanEl);

  initOnScrollHeaderEvent(headerEl);
  mobileToggleEl.addEventListener(
    "click",
    toggleMobileMenuHandler.bind(null, headerEl)
  );
}
